import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCrop, FiLayers, FiEdit3, FiBriefcase, FiTag, FiRepeat } = FiIcons;

const Products = () => {
  const products = [
    {
      icon: FiCrop,
      title: 'T-Shirts & Apparel',
      description: 'Ready-made and custom T-shirts, casual wear, and everyday apparel in a range of sizes and fabrics.'
    },
    {
      icon: FiLayers,
      title: 'Fabrics & Raw Materials',
      description: 'Cotton, silk, wool, and synthetic fabrics supplied by the meter, roll, or bulk lot for manufacturers and traders.'
    },
    {
      icon: FiEdit3,
      title: 'Custom Design & Printing',
      description: 'Custom prints, patterns, and designs on garments and fabric, made to your artwork and specifications.'
    },
    {
      icon: FiBriefcase,
      title: 'Uniforms & Corporate Wear',
      description: 'Bulk uniform stitching and supply for schools, businesses, and institutions with consistent quality.'
    },
    {
      icon: FiTag,
      title: 'Private Label Manufacturing',
      description: 'Your brand, our production - custom labelling and packaging for clothing brands and retailers.'
    },
    {
      icon: FiRepeat,
      title: 'Wholesale & Bulk Trading',
      description: 'Consistent bulk supply of clothing and textile goods for wholesalers, retailers, and repeat buyers.'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What We Provide
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From fabric to finished garments, here is what Thread & Textile India brings to your
            clothing and textile trading needs.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={product.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="bg-gradient-to-br from-gray-50 to-blue-50 p-8 rounded-2xl hover:shadow-lg transition-all duration-300 group border border-gray-100"
            >
              <div className="w-14 h-14 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <SafeIcon icon={product.icon} className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{product.title}</h3>
              <p className="text-gray-600 leading-relaxed">{product.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
